module.exports = __webpack_public_path__ + "static/media/adults.2e7ad1d9.png";